// extracted by mini-css-extract-plugin
module.exports = {"refuse":"approvalModal_refuse__rwA2k","btns":"approvalModal_btns__3uZF3"};